
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Familypicnicspotnearnagpur() {



  const cardData =
  {
    keyword: ' Family Picnic Spot Near Nagpur',
    heading:  'Woodland Escape: Family Picnic Spot Near Nagpur',
    headingDescription: 'Family Picnic Spot Near Nagpur is the perfect choice for a refreshing day out with loved ones, surrounded by lush greenery and peaceful lakes. Just a short drive from the city, these picnic destinations offer a mix of fun, relaxation, and scenic beauty. Popular spots like Ambazari Lake, Waki Woods, Khindsi Lake, and Adasa Village provide ideal settings for families to enjoy boating, outdoor games, and nature walks. With open spaces, shaded gardens, and calm environments, family picnic spots near Nagpur create the perfect atmosphere for bonding, laughter, and quality time away from the city’s hustle and bustle',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



   "services": [
    {
      "name": "Family Picnic Spot Near Nagpur",
      "description": "Woodland Escape Resort is one of the best family picnic spots near Nagpur, offering a safe, clean, and scenic environment where families can relax and reconnect. Surrounded by lush greenery, open lawns, and peaceful nature trails, the resort provides the perfect backdrop for bonding and fun. Enjoy outdoor games, picnic lunches, and refreshing nature walks, all within a short drive from the city."
    },
    {
      "name": "Nagpur Family Outing Place",
      "description": "Looking for the perfect family outing place near Nagpur? Woodland Escape Resort offers a beautiful combination of fun, comfort, and nature. Families can engage in outdoor activities like cycling, volleyball, and nature walks, while kids enjoy dedicated play zones. With delicious food and a peaceful atmosphere, it’s the ideal spot for a memorable family getaway."
    },
    {
      "name": "Nagpur Kids Friendly Picnic Spot",
      "description": "Woodland Escape Resort is a kid-friendly picnic destination near Nagpur, designed for both fun and learning. Children can enjoy safe outdoor play areas, interactive farm experiences, and short nature trails. Parents can relax while kids explore the natural surroundings, making it a perfect balance of entertainment and education in nature."
    },
    {
      "name": "Nagpur Family Day Out",
      "description": "Spend your next family day out at Woodland Escape Resort near Nagpur. The resort offers plenty of open spaces, shaded seating, and outdoor games suitable for all age groups. Families can indulge in freshly cooked meals, enjoy peaceful walks, and take part in group activities, making it a day full of laughter and connection."
    },
    {
      "name": "Affordable Family Picnic Nagpur",
      "description": "For families seeking an affordable yet enjoyable picnic near Nagpur, Woodland Escape Resort provides the perfect option. With budget-friendly packages that include meals, activities, and access to natural surroundings, it offers incredible value. Families can relax, play, and dine together without worrying about cost, making it ideal for all budgets."
    },
    {
      "name": "Nagpur Family Park",
      "description": "Woodland Escape Resort is like a private family park near Nagpur, surrounded by greenery and equipped with picnic spots, gardens, and walking paths. Families can enjoy a peaceful retreat away from the city while engaging in light outdoor games, photo sessions, and leisure time amid nature’s beauty."
    },
    {
      "name": "Nagpur Family Picnic Places",
      "description": "Among the top family picnic places near Nagpur, Woodland Escape Resort stands out for its blend of comfort and outdoor excitement. Enjoy games, guided nature walks, and tasty homemade-style food. The resort’s relaxing ambiance makes it a perfect location for day trips or weekend picnics with loved ones."
    },
    {
      "name": "Nagpur Outdoor Activities Spot",
      "description": "For families who love adventure, Woodland Escape Resort offers a variety of outdoor activities near Nagpur. From nature trails and cycling to outdoor sports and group games, there’s something for everyone. The resort’s peaceful environment ensures a healthy mix of excitement and relaxation throughout the day."
    },
    {
      "name": "Nagpur Family Resort Picnic",
      "description": "Woodland Escape Resort offers a complete family resort picnic experience near Nagpur. Enjoy a full day of fun-filled activities, delicious meals, and quality family time. With ample space for kids to play and adults to relax, it’s the ultimate destination for families seeking a refreshing one-day escape in nature."
    },
    {
      "name": "Nagpur Weekend Family Trip",
      "description": "Plan a weekend family trip near Nagpur at Woodland Escape Resort. The resort offers cozy accommodations, wholesome food, and enjoyable outdoor games, perfect for a short stay. Surrounded by nature, it’s an ideal getaway for families wanting to unwind and spend quality time together away from the city’s stress."
    },
    {
      "name": "Nagpur Picnic Area for Families",
      "description": "Woodland Escape Resort features dedicated picnic areas for families near Nagpur, equipped with comfortable seating, shaded spaces, and easy access to rest areas. Enjoy picnic meals, outdoor games, and scenic views while the kids explore the natural surroundings safely under supervision."
    },
    {
      "name": "Nagpur Nature Picnic Spot",
      "description": "Experience nature at its best with a family picnic at Woodland Escape Resort near Nagpur. Families can stroll through green fields, enjoy bird watching, and relax in open-air gazebos. The resort provides a serene escape where you can breathe fresh air and enjoy the natural beauty all around."
    },
    {
      "name": "Nagpur Riverside Family Picnic",
      "description": "For a peaceful riverside picnic near Nagpur, Woodland Escape Resort offers a stunning setting along calm water streams and shaded trees. Families can enjoy meals by the riverside, play outdoor games, and take part in light nature activities. It’s a serene and picture-perfect location for relaxation and fun."
    },
    {
      "name": "Nagpur Family Tour Booking",
      "description": "Book your family tour to Woodland Escape Resort near Nagpur with ease. The resort offers customizable packages for families that include food, activities, and guided experiences. Advance booking ensures hassle-free entry, personalized arrangements, and a smooth, memorable outing for everyone."
    },
    {
      "name": "Nagpur One Day Family Trip",
      "description": "Woodland Escape Resort is an ideal destination for a one-day family trip near Nagpur. Spend the day surrounded by nature, enjoy local cuisine, take part in outdoor activities, and unwind with your loved ones. It’s a short and sweet getaway that promises joy, peace, and togetherness for the entire family."
    }
  ],
  "tableData": [
    ["- Family Picnic Spot Near Nagpur", "- Nagpur Family Outing Place"],
    ["- Nagpur Kids Friendly Picnic Spot", "- Nagpur Family Day Out"],
    ["- Affordable Family Picnic Nagpur", "- Nagpur Family Park"],
    ["- Nagpur Family Picnic Places", "- Nagpur Outdoor Activities Spot"],
    ["- Nagpur Family Resort Picnic", "- Nagpur Weekend Family Trip"],
    ["- Nagpur Picnic Area for Families", "- Nagpur Nature Picnic Spot"],
    ["- Nagpur Riverside Family Picnic", "- Nagpur Family Tour Booking"],
    ["- Nagpur One Day Family Trip", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Family Picnic Spot Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is the ideal family picnic spot near Nagpur, offering a delightful combination of nature, comfort, and fun-filled activities. Set in the midst of a peaceful forest, it provides a safe and refreshing space for families to relax, bond, and create cherished memories together."
  },
  {
    "WhyChooseheading": "Peaceful Forest Setting",
    "WhyChoosedescription": "Surrounded by lush greenery and the calming sounds of nature, Woodland Escape Resort offers a tranquil forest ambiance perfect for family outings. The serene environment allows you to unwind while your children explore and enjoy the beauty of the outdoors. It’s a wonderful way to escape the city and reconnect with nature as a family."
  },
  {
    "WhyChooseheading": "Spacious Picnic Areas and Family Zones",
    "WhyChoosedescription": "Our resort features well-maintained lawns, shaded picnic spots, and comfortable seating areas designed for family gatherings. Whether you’re sharing meals, playing games, or simply enjoying the peaceful atmosphere, the open and secure surroundings make it an enjoyable experience for guests of all ages."
  },
  {
    "WhyChooseheading": "Fun Activities for All Age Groups",
    "WhyChoosedescription": "Woodland Escape Resort offers a variety of activities that every family member will love. Kids can enjoy outdoor games, nature walks, and mini adventure setups, while adults can relax by the pond, take part in forest treks, or enjoy leisurely walks through scenic trails. There’s something exciting for everyone to enjoy together."
  },
  {
    "WhyChooseheading": "Tasty and Fresh Homemade Meals",
    "WhyChoosedescription": "Treat your family to delicious meals made from locally sourced and farm-fresh ingredients. Our kitchen serves authentic regional dishes and picnic-style food options, ensuring that everyone enjoys a healthy and flavorful dining experience surrounded by the natural charm of the forest."
  },
  {
    "WhyChooseheading": "Safe and Family-Friendly Environment",
    "WhyChoosedescription": "Safety and comfort are our top priorities at Woodland Escape Resort. With clean surroundings, attentive staff, and well-organized facilities, families can relax and enjoy their picnic without any worries. It’s the perfect destination for a secure and refreshing day in nature."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located just a short drive from Nagpur, Woodland Escape Resort is easy to reach for a spontaneous family picnic or weekend getaway. The scenic road leading to the resort offers glimpses of countryside charm, setting the mood for a fun and relaxing family day amidst the forest."
  }
]



  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort the best family picnic spot near Nagpur?",
    answer: "Woodland Escape Resort offers the perfect blend of fun, relaxation, and nature — making it one of the best family picnic spots near Nagpur. Families can enjoy open green spaces, nature walks, adventure games, and delicious local food all in one place."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "The resort is located approximately 45 km from Nagpur and takes just about 1 to 1.5 hours to reach by car. It’s an easy and scenic drive, ideal for families planning a quick day trip or weekend getaway."
  },
  {
    question: "What family-friendly activities are available at the resort?",
    answer: "There’s something for everyone at Woodland Escape Resort! Kids can enjoy outdoor games and animal interactions, while adults can relax by the lakeside, take part in adventure activities, or simply unwind in the peaceful surroundings."
  },
  {
    question: "Is food available for family picnics?",
    answer: "Yes, our resort serves freshly prepared meals and snacks made with local ingredients. We offer a variety of options including vegetarian and non-vegetarian dishes, all included in our family picnic packages."
  },
  {
    question: "Is the resort safe and suitable for children and elderly guests?",
    answer: "Absolutely! Woodland Escape Resort is family-oriented and ensures a safe and comfortable environment for guests of all ages. Our staff is attentive, and the entire property is well-maintained and child-friendly."
  },
  {
    question: "How can we book a family picnic at Woodland Escape Resort?",
    answer: "Booking is easy! You can contact our team via phone, WhatsApp, or through our official website. We recommend advance booking for weekends and holidays to ensure availability and personalized arrangements for your family."
  }
];

const testimonials = [
  {
    name: "Mr. Ajay & Family, Nagpur",
    text: "Our family had a wonderful picnic at Woodland Escape Resort! The atmosphere was peaceful, the food was delicious, and the kids enjoyed every moment. It’s the perfect family picnic spot near Nagpur!"
  },
  {
    name: "Miss. Neha & Family, Wardha",
    text: "We visited Woodland Escape Resort for a family day out, and it was amazing! The greenery, play areas, and friendly staff made the day special. Highly recommended for families looking for a fun and relaxing picnic near Nagpur."
  }
];


      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Family Picnic Spot Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/family-picnic-spot-near-nagpur.jpg",
  "description": "Spend quality time with your loved ones at Woodlandescape Resort — the perfect family picnic spot near Nagpur. Enjoy safe, fun-filled activities, kids-friendly zones, and beautiful natural surroundings for a relaxing family day out.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1123"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1199",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/family-picnic-spot-near-nagpur"
  }
};



  return (
    <div>
<Helmet>
  <title>Family Picnic Spot Near Nagpur | Kids Friendly Resort | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a fun-filled family picnic near Nagpur at Woodlandescape Resort. Perfect for kids and families with adventure games, open green spaces, and refreshing natural surroundings for your next family outing." 
  />
  <meta 
    name="keywords" 
    content="Family Picnic Spot Near Nagpur, Nagpur Family Outing Place, Nagpur Kids Friendly Picnic Spot, Nagpur Family Day Out, Affordable Family Picnic Nagpur, Nagpur Family Park, Nagpur Family Picnic Places, Nagpur Outdoor Activities Spot, Nagpur Family Resort Picnic, Nagpur Weekend Family Trip, Nagpur Picnic Area for Families, Nagpur Nature Picnic Spot, Nagpur Riverside Family Picnic, Nagpur Family Tour Booking, Nagpur One Day Family Trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/3.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Familypicnicspotnearnagpur;